export class City {
    constructor(public id: string, public name: string) { }
  }